"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedLocationTypes = exports.getLocalizedLocationType = exports.DEFAULT_LOCATION_TYPE_MAPPING = void 0;
/**
 * Maps Algolia location types to their corresponding dictionary keys
 * This allows for proper localization of location type names
 */
exports.DEFAULT_LOCATION_TYPE_MAPPING = {
    "Urgent Care": "hub.locationTypes.urgentCare",
    "Emergency Care": "hub.locationTypes.emergencyCare",
    "Pharmacy": "hub.locationTypes.pharmacy",
    "Labs": "hub.locationTypes.labs",
    "Specialized Clinics": "hub.locationTypes.specializedClinics",
    "Radiology": "hub.locationTypes.radiology",
    "Imaging Centers": "hub.locationTypes.imagingCenters",
    "Institutes": "hub.locationTypes.institutes",
    "Hospitals": "hub.locationTypes.hospitals"
};
/**
 * Gets the localized location type name using the dictionary
 * @param locationType - The raw location type from Algolia
 * @param getDictionaryValue - Function to get dictionary values
 * @param mapping - Optional custom mapping of location types to dictionary keys
 * @returns Localized location type name
 */
const getLocalizedLocationType = (locationType, getDictionaryValue, mapping = exports.DEFAULT_LOCATION_TYPE_MAPPING) => {
    // Remove suffixes like " - Primary" from location type for mapping
    const baseType = locationType.split(" - ")[0];
    // Get the dictionary key for this location type
    const dictionaryKey = mapping[baseType];
    if (dictionaryKey) {
        // Get the localized value from the dictionary
        const localizedValue = getDictionaryValue(dictionaryKey);
        // If the localized value is different from the key, use it
        if (localizedValue !== dictionaryKey) {
            // If the original had a suffix, append it to the localized value
            if (locationType.includes(" - ")) {
                const suffix = locationType.split(" - ")[1];
                return `${localizedValue} - ${suffix}`;
            }
            return localizedValue;
        }
    }
    // Fall back to the original location type if no mapping found
    return locationType;
};
exports.getLocalizedLocationType = getLocalizedLocationType;
/**
 * Gets localized location types for an array of location types
 * @param locationTypes - Array of raw location types from Algolia
 * @param getDictionaryValue - Function to get dictionary values
 * @param mapping - Optional custom mapping of location types to dictionary keys
 * @returns Array of localized location type names
 */
const getLocalizedLocationTypes = (locationTypes, getDictionaryValue, mapping = exports.DEFAULT_LOCATION_TYPE_MAPPING) => {
    return locationTypes.map(locationType => (0, exports.getLocalizedLocationType)(locationType, getDictionaryValue, mapping));
};
exports.getLocalizedLocationTypes = getLocalizedLocationTypes;
